// extracted by mini-css-extract-plugin
export default {"VersionList":"VersionList_VersionList__l6c3Z","SegmentedContent":"VersionList_SegmentedContent__Add4s","new":"VersionList_new__--vQ8"};